import { apiHelper } from "./api_helper";

export const searchApi = {
    search: (data) => apiHelper.post('search', data)
}